var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Table" },
    [
      _vm._m(0),
      _vm._l(_vm.logs, function(log, index) {
        return _c("div", { key: index, staticClass: "Table__item" }, [
          _c(
            "div",
            {
              staticClass:
                "Table__item-wrapper Table__item-wrapper--BaseQBSyncAudit row row--align-center"
            },
            [
              _c("div", { staticClass: "column" }, [
                _c("label", { staticClass: "fs-15 fc-light" }, [
                  _c(
                    "time",
                    {
                      staticClass: "fs-15",
                      attrs: {
                        datetime: _vm._f("datetime")(
                          log.updated_at,
                          "YY-MM-DD hh:mm:ssZ"
                        )
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("datetime")(log.updated_at, "MM/DD/YY")
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("label", { staticClass: "fs-15" }, [
                  _vm._v(
                    "\n          " + _vm._s(log.displayType) + "\n        "
                  )
                ])
              ]),
              _c("div", { staticClass: "column" }, [
                _c("label", { staticClass: "fs-15 fc-light" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(log.completed ? "Pass" : "Fail") +
                      "\n        "
                  )
                ])
              ])
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "Table__head-wrapper Table__head-wrapper row" },
      [
        _c(
          "label",
          {
            staticClass: "Table__header-lbl Table__header-lbl--BaseQBSyncAudit"
          },
          [_vm._v("Date")]
        ),
        _c(
          "label",
          {
            staticClass: "Table__header-lbl Table__header-lbl--BaseQBSyncAudit"
          },
          [_vm._v("Type")]
        ),
        _c(
          "label",
          {
            staticClass: "Table__header-lbl Table__header-lbl--BaseQBSyncAudit"
          },
          [_vm._v("Notes")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }